import callApi, { CallApiResult, getCustomerId } from 'src/api';
import { LanguageKeys } from 'src/core/provider/AppMeta';
import VideoRating from 'src/entities/video/VideoRating';

/* Video Topics */
export const fetchVideoTopics = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi('/api/video/' + customerId + '/topics');
};

/* Video Categories by topic */
export const fetchVideoCategoriesByTopic = (topic: string): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    return callApi(`/api/video/${customerId}/topics/${topic}/categories`);
};

/* Submit Video Ratings */
export const submitVideoRating = (id: string, data: VideoRating[]): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = `/api/video/${customerId}/video/${id}/rate`;
    return callApi(endpoint, { method: 'PUT', data });
};

/* Fetch Video Languages */
export const fetchVideoLanguages = (topic: string): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = `/api/video/${customerId}/customerVideoLanguages/${topic}`;
    return callApi(endpoint, { method: 'GET' });
};

/* SetVideoLanguages */
export const submitSelectVideoLanguages = (data: LanguageKeys[]): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/video/' + customerId + '/customerVideoLanguages';
    return callApi(endpoint, { method: 'PUT', data });
};

/* Fetch Next Video */

export const fetchNextVideo = (): Promise<CallApiResult> => {
    const customerId = getCustomerId();
    const endpoint = '/api/video/' + customerId + '/nextVideo';
    return callApi(endpoint);
};
